import React from 'react'
import styled from 'styled-components'
import { FontSize1 } from '../../GlobalStyles'
import ChartImg from '../../assets/images/detail/size_chart.jpeg'

const Wrapper = styled.div`
    /* background-color: greenyellow; */
    margin-top: 2rem;
    ul {
        list-style: disc;
        font-size: ${FontSize1};
        margin-left: 2rem;
        display: grid;
        gap: 7px;
        margin-top: 10px;
    }
    h4 {
        font-size: ${FontSize1};
    }
    div {
        margin-bottom: 1.6rem;
    }
`
export const DescriptionTab = () => {
    return (
        <Wrapper>
            <ul>
                <li>Kurung modern with kimono pattern</li>
                <li>Material premium chiffon with beads</li>
                <li>Include inner sleevelss, cardigan and ribbon.</li>
                <li>Zip : Back and skirt (half rubber skirt)</li>
                <li>"A" skirt pattern.</li>
                <li>Model is wearing XS size</li>
                <li>Due to lighting effects, monitor’s brightness, contrast setting, etc, they could be some slight differences in the colour tone of the pictures and the actual item.</li>
            </ul>
        </Wrapper>
    )
}

export const ChartTab = () => {
    return (
        <Wrapper>
            <img src={ChartImg} alt="gambar" />
        </Wrapper>
    )
}

export const GuideTab = () => {
    return (
        <Wrapper>
            <ul>
                <li>All measurements are taken with the garment laid flat, buttoned and/or zipped.</li>
                <li>Please check measurement especially on bust, waist, and hip.</li>
                <li>Size might be smaller than your actually size.</li>
                <li>Unless otherwise specified, measurements are taken from the highest point of shoulder. Size charts have been provided as general guide for determining fit.</li>
                <li>However, there might be 0.5 to 1 inch differences in the measurement given due to the different stretchable quality of the material.</li>
                <li>Please check your measurement before purchase. Kindly contact our Sales Team or Dropshipper to assist.</li>
                <li>We do not take responsibility for the wrong size choosen.</li>
            </ul>
        </Wrapper>
    )
}

export const ShippingTab = () => {
    return (
        <Wrapper>
            <div>
                <h4>Shipping on Peak Season / During Sales</h4>
                <ul>
                    <li>Process within 3 - 4 days of working hour. Days to ship may be vary, depending on volume of orders received.</li>
                    <li>Please be advised that order placed during sales or peak season may take longer to process due to bulk orders. Urgent orders are strongly discouraged.</li>
                    <li>Days parcel to arrive depending on your place domicile. Delivery to Klang Valley normally take 2 - 3 business days. Peninsular Malaysia within 4-5 days and East Malaysia may take 1-2 weeks. Depending on the courier service in the area.</li>
                    <li>Item purchased during sales are not refundable / exchange / return</li>
                </ul>
            </div>
            <div>
                <h4>Shipping for Pre Order Item</h4>
                <ul>
                    <li>Delivery date  will be display at pre order item on website. Item will be ship out according to the date display.</li>
                    <li>You may get your tracking early as we will process your order once payment made, and print out your consignment noted.</li>
                    <li>But order will be ship out once item arrive in our HQ.</li>
                    <li>Order will be post by batch according to the order number.</li>
                    <li>Tracking will be in record system once item already ship out within the date given.</li>
                </ul>
            </div>
        </Wrapper>
    )
}